
// src/reducers/organizations-reducer.js

import { mergeArray, deleteArray, findTree, replaceTree } from '../helpers/store'

import { 
  FETCH_ORGANIZATIONS,
  FETCH_ORGANIZATIONS_REQUESTED,
  FETCH_ORGANIZATIONS_COMPLETED,
  FETCH_ORGANIZATIONS_FAILED,
  FETCH_ORGANIZATION,
  FETCH_ORGANIZATION_REQUESTED,
  FETCH_ORGANIZATION_COMPLETED,
  FETCH_ORGANIZATION_FAILED,
  FETCH_ORGANIZATION_MEMBERS,
  FETCH_ORGANIZATION_MEMBERS_REQUESTED,
  FETCH_ORGANIZATION_MEMBERS_COMPLETED,
  FETCH_ORGANIZATION_MEMBERS_FAILED,
  UPDATE_ORGANIZATION_MEMBERSHIP,
  UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED,
  UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED,
  UPDATE_ORGANIZATION_MEMBERSHIP_FAILED,
  FETCH_ORGANIZATION_GROUPS,
  FETCH_ORGANIZATION_GROUPS_REQUESTED,
  FETCH_ORGANIZATION_GROUPS_COMPLETED,
  FETCH_ORGANIZATION_GROUPS_FAILED,
} from '../actions/organizations'

const initialState = {
  isFetching: false,
  isRequesting: false,
  items: undefined,
}

export default function organizationsReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_ORGANIZATIONS_REQUESTED:
  case FETCH_ORGANIZATION_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case FETCH_ORGANIZATION_MEMBERS_REQUESTED:
  case UPDATE_ORGANIZATION_MEMBERSHIP_REQUESTED:
  case FETCH_ORGANIZATION_GROUPS_REQUESTED:
    return Object.assign({}, state, {
      isRequesting: true,
    })

  case FETCH_ORGANIZATIONS_FAILED:
  case FETCH_ORGANIZATION_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case FETCH_ORGANIZATION_MEMBERS_FAILED:
  case UPDATE_ORGANIZATION_MEMBERSHIP_FAILED:
  case FETCH_ORGANIZATION_GROUPS_FAILED:
    return Object.assign({}, state, {
      isRequesting: false,
    })

  case FETCH_ORGANIZATIONS_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: action.results,
    })

  case FETCH_ORGANIZATION_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      items: [].concat(replaceTree('organization_id', state.items, action.results))
    })

  case FETCH_ORGANIZATION_MEMBERS_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      members: action.results,
    })

  case UPDATE_ORGANIZATION_MEMBERSHIP_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      members: action.results,
    })

  case FETCH_ORGANIZATION_GROUPS_COMPLETED:
    return Object.assign({}, state, {
      isRequesting: false,
      groups: action.results
    })

  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organizations-reducer.js